import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreatorScreen from './screens/Creator'
import NewProjectScreen from './screens/NewProject'

export default () => (
  <Switch>
    <Route path={'/:projectName'} component={CreatorScreen} />
    <Route component={NewProjectScreen} />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/router.js